import api from '../../api'

class WXOpenApp {
  constructor() {
    this.jsApiList = ['onMenuShareTimeline', 'onMenuShareAppMessage']
  }

  async init(callback) {
    try {
      const url = location.href.split('#')[0]
      const response = await api.callPromise('GET', '/wechat/jssdk_sign/', { url })

      if (response.data && response.data.code === 0) {
        const { appId, timestamp, nonceStr, signature, openTagList, jsApiList } = response.data.data
        wx.config({
          debug: false,
          appId,
          timestamp,
          nonceStr,
          signature,
          jsApiList: this.jsApiList,
          openTagList,
        })

        wx.ready(() => {
          // 在这里调用微信JS-SDK提供的各种接口
          console.log('微信JS-SDK配置成功')
          callback && callback()
        })

        wx.error((res) => {
          console.error('微信JS-SDK配置失败:', res)
        })
      }
    } catch (error) {
      console.error('初始化微信JS-SDK失败:', error)
    }
  }

  static getInstance() {
    if (!WXOpenApp.instance) {
      WXOpenApp.instance = new WXOpenApp()
    }
    return WXOpenApp.instance
  }
}

export default WXOpenApp
